import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { formatDistanceToNow } from 'date-fns';
import MyTable from '@/components/layout/MyTable/MyTable.vue';
import MyTableCell from '@/components/layout/MyTable/MyTableCell.vue';
import DisconnectConnectionDialog from './DisconnectConnectionDialog.vue';
import OAuthConnectionService, { OAuthConnection } from '@/services/OAuthConnectionService';
import notificationService from '@/services/NotificationService';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'OAuthConnectionList',
  setup(__props, { expose }) {

const tableColumns = [{ label: 'CLIENT' }, { label: 'STATUS' }, { label: 'LAST USED' }, { label: '' }];

const connections = ref<OAuthConnection[]>([]);
const loading = ref(false);
const disconnectDialogRef = ref<InstanceType<typeof DisconnectConnectionDialog> | null>(null);

const loadConnections = async () => {
  loading.value = true;
  try {
    const companyId = store.state.company?.id || undefined;
    const response = await OAuthConnectionService.list(companyId);
    connections.value = response.data;
  } catch (error) {
    notificationService.error('Failed to load connections');
  } finally {
    loading.value = false;
  }
};

const formatLastUsed = (date: string | null): string => {
  if (!date) return 'Never';
  try {
    return formatDistanceToNow(new Date(date), { addSuffix: true });
  } catch (error) {
    return 'Invalid date';
  }
};

const blurTarget = (event: Event) => {
  (event.target as HTMLElement).blur();
};

const handleDisconnect = (connection: OAuthConnection) => {
  if (disconnectDialogRef.value) {
    disconnectDialogRef.value.show(connection);
  }
};

expose({ loadConnections });

onMounted(() => {
  loadConnections();
});

return { __sfc: true,tableColumns, connections, loading, disconnectDialogRef, loadConnections, formatLastUsed, blurTarget, handleDisconnect, MyTable, MyTableCell, DisconnectConnectionDialog }
}

})